<template>
	<div class="form-container-80">
		<form method="POST" :action="action">
			<div class="columns is-vcentered is-gapless">
				<div class="column is-6">
					<div class="has-background-warning radius-lg-right card p20">
						<h3 class="has-text-weight-bold has-text-white has-text-centered is-size-6 mb30">
                            {{this.$translate.text('choose_account_type')}}
						</h3>
						<div class="columns is-mobile mb30 mt20">
							<div class="column is-6-desktop is-6-tablet is-6-mobile user-type">
								<div class="is-inline-block position-relative">
									<input type="radio" name="type" value="client" v-model="form.type">
									<label class="is-block icon-container p20">
										<i class="icon_client has-text-white"></i>
									</label>
								</div>
							</div>
							<div class="column is-6-desktop is-6-tablet is-6-mobile user-type">
								<div class="is-inline-block position-relative">
									<input type="radio" name="type" value="merchant" v-model="form.type">
									<label class="is-block icon-container p20">
										<i class="icon_merchant has-text-white"></i>
									</label>
								</div>
							</div>
						</div>
						<p v-if="form.type == 'client'" class="has-text-white has-text-centered has-text-weight-bold is-size-6">
							{{t('register_as_client')}}
						</p>
						<p v-if="form.type == 'merchant'" class="has-text-white has-text-centered has-text-weight-bold is-size-6">
							{{t('register_as_merchant')}}
						</p>
					</div>
				</div>
				<div class="column is-6 mt30-mobile">
					<div class="has-background-white card p20">
						<h3 class="has-text-weight-bold has-text-primary has-text-centered is-size-6 mb30">{{this.$translate.text('store_your_data')}} </h3>
						<div class="pr30 pl30">
							<div class="field mb30">
								<div class="control">
									<input name="name" class="input line-input is-primary has-text-centered" required autocomplete="name" v-model="form.name" v-validate="{ required: true , alpha_spaces:true }" :class="{'is-danger': errors.has('name') }" type="text" :placeholder="t('name')" >
									<div v-show="errors.has('name')" class="help is-danger has-text-right">{{ errors.first('name') }}</div>
								</div>
							</div>
							<div class="field mb30">
								<div class="control">
									<input name="email" class="input line-input is-primary has-text-centered" required autocomplete="email" v-model="form.email" v-validate="{ required: true , email:true }" :class="{'is-danger': errors.has('email') }" type="text" :placeholder="t('email')" >
									<div v-show="errors.has('email')" class="help is-danger has-text-right">{{ errors.first('email') }}</div>
								</div>
							</div>
							<div class="field mb30">
								<div class="control">
									<input name="phone" class="input line-input is-primary has-text-centered" required autocomplete="phone" v-model="form.phone" v-validate="{ required: true , digits:11 }" :class="{'is-danger': errors.has('phone') }" type="text" :placeholder="t('phone')" >
									<div v-show="errors.has('phone')" class="help is-danger has-text-right">{{ errors.first('phone') }}</div>
								</div>
							</div>
							<div class="field mb30">
								<div class="control">
									<input name="password" class="input line-input is-primary has-text-centered" v-model="form.password" v-validate="{ required: true , min:6 ,max:255 }" :class="{'is-danger': errors.has('password') }" :type="passwordFieldType" :placeholder="t('password')" ref="password">
									<span v-show="errors.has('password')" class="help is-danger has-text-right">{{ errors.first('password') }}</span>
								</div>
							</div>
							<div class="field mb30">
								<div class="control">
									<input name="password_confirmation" class="input line-input is-primary has-text-centered" v-model="form.password_confirmation" v-validate="{ required: true , confirmed:'password' }" :class="{'is-danger': errors.has('password_confirmation') }" :type="passwordFieldType" :placeholder="t('password_confirmation')" >
									<span v-show="errors.has('password_confirmation')" class="help is-danger has-text-right">{{ errors.first('password_confirmation') }}</span>
								</div>
							</div>
							<div class="columns is-multiline">
								<div class="column is-12">
									<div v-if="form.type == 'merchant'" class="field">
										<input class="is-checkradio is-rtl is-primary form-check-input" v-validate="{required:true}" type="checkbox" name="privacy" id="privacy" >
										<label class="has-text-grey ml0" for="privacy">
											<small>{{ this.$translate.text('agree') }}</small>
										</label>
										<a href="#" @click.prevent="showTerms('merchant')" target="_blank">{{ termslabel }}</a>
										<span v-show="errors.has('privacy')" class="help is-danger has-text-right">{{ errors.first('privacy') }}</span>
									</div>
									<div v-if="form.type == 'client'" class="field">
                                                                                <input class="is-checkradio is-rtl is-primary form-check-input" v-validate="{required:true}" type="checkbox" name="privacy" id="privacy" >
                                                                                <label class="has-text-grey ml0" for="privacy">
                                                                                        <small>{{ this.$translate.text('agree') }}</small>
                                                                                </label>
										<a href="#" @click.prevent="showTerms('client')" target="_blank">{{ featureslabel }}</a>
                                                                                <span v-show="errors.has('privacy')" class="help is-danger has-text-right">{{ errors.first('privacy') }}</span>
									</div>
								
								</div>
								<div class="column is-12" v-if="form.type == 'merchant'">
									<div v-html="termsContent" class="terms-container" id="terms_container" style="display: none;">
									</div>								
								</div>
								<div class="column is-12" v-if="form.type == 'client'">
									<div v-html="advantagesContent" class="terms-container" id="terms_container" style="display: none;">
									</div>							
								</div>
								
							</div>


							<div class="field mt90">
								<div class="control has-text-centered">
									<button @click.prevent="onSubmit" type="submit" class="button btn-warning hvr-shutter-out-vertical hvr-primary is-rounded pr20 pl20" :disabled='errors.any() || isDisabled'>{{ this.$translate.text('register') }} </button>
									<p class="has-text-primary has-text-weight-bold mt20 is-size-7">{{ this.$translate.text('have_account') }}<a  :href="`/${this.sitelocale}/login`" class="has-text-warning">{{ this.$translate.text('login') }}</a></p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</form>
	</div>
</template>
<script>
	import axios from 'axios';
	import trans from '../translation/user.json';
	import { Validator , mapFields} from 'vee-validate';
	import arabic from 'vee-validate/dist/locale/ar';
	export default {
		name: 'Register',
		props: {
			action: {
				type: String,
				required: true
			},
			sitelocale:{
				type: String,
				required: true
			},
			termsContent:{
				type: String,
				required: true
			},
			advantagesContent:{
				type: String,
				required: true
			},
			featureslabel:{
				type: String,
				required: true,
				default:"مزايا"
			},
			termslabel:{
				type: String,
				required: true,
				default:"الشروط و الاحكام"
			}
		},
		data(){
			return{
				form : {
					type: 'client',
					name: '',
					email:'',
					phone: '',
					password:'',
					password_confirmation:''
				},
				passwordFieldType: 'password',
				isDisabled:false

			}
		},
		mounted(){
			this.$translate.setLang(this.sitelocale);

		},
		locales: trans,
		created(){
			this.$validator.localize('ar', {
				messages: arabic.messages,
				attributes: trans.ar,
				custom:trans.ar.custom
			});
			this.$validator.localize('en', {
				custom:trans.en.custom
			});

			Validator.localize(this.sitelocale);


		},
		methods:{
			onSubmit(){
				this.$validator.validateAll().then((result) => {
					if (result) {
						const action = this.action;
						axios.post(action, this.form)
						.then( response => {
							this.showAlert('success' , `${this.$translate.text('register_successfully')}` , `${this.$translate.text('you_can_login')}` , '');
							setTimeout(()=>{
								window.location.href = `/${this.sitelocale}/login`;
							}, 2000);
							this.isDisabled=true

						})
						.catch(error => {
							this.showAlert('error',
								`${this.$translate.text('error_in_data')}` ,
								'text',
								`<ul class="AlertList">`+Object.values(error.response.data.errors).map(error => `<li class="mb5 is-size-6">${error[0]}</li>`).join(' ')+`</ul>`
								)
							this.isDisabled=false;
							console.clear();
						})
						.then(()=>{

							setTimeout(()=>{

							}, 3500);
						});

					}


				});

			},
			showAlert(type , title , text , html){
				this.$swal({
					type: type,
					title: title,
					text: text,
					html: html,
					showConfirmButton: false,
					timer: 2000,
					customClass: type == 'success' ? 'swal2-is-success' : 'swal2-is-danger',
					backdrop: `
					rgba(36, 140, 204, 0.5)
					`
				});
			},
			showTerms(type){
				if(type == 'merchant'){
					$("#terms_container").slideToggle();
				}else if(type == 'client'){
					$("#terms_container").slideToggle();
				}
			}
		}

	};
</script>

<style lang="scss">

</style>


